import { Box, Icon, Text } from '@betty/moonlight';
import { useTranslation } from '@betty/i18n';
import { memo, useMemo } from 'react';
import { PriceProps } from './Price.types';

function Price({ amount, strikethrough }: PriceProps) {
  const { i18n } = useTranslation();

  const formattedAmount = useMemo(
    () => new Intl.NumberFormat(i18n.language).format(amount),
    [i18n.language, amount],
  );

  return (
    <Box
      position="relative"
      flexDirection="row"
      alignItems="center"
      gap="space-100"
      opacity={strikethrough ? 0.3 : 1}
    >
      <Icon
        name="bettyCoin"
        gradient="accentBackground"
        width="space-400"
        height="space-400"
      />
      <Text variant="body-s" color="darkSurfacePrimary">
        {formattedAmount}
      </Text>
      {strikethrough ? (
        <Box
          position="absolute"
          height="space-050"
          left="space-0"
          right="space-0"
          backgroundColor="whiteBackground"
        />
      ) : null}
    </Box>
  );
}

export default memo(Price);
